// extracted by mini-css-extract-plugin
export default {"tag":"planning-tag_tag__fI8uO","tagTooltip":"planning-tag_tagTooltip__5gQh-","tagTooltipTitle":"planning-tag_tagTooltipTitle__C+Iv-"};